import { toIntOrNull, toBoolOrNull } from '@utils/parse';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultScreeningProgress } from '@/types/screening/screening-progress';
import type {
    IDonationDetailsFormValues,
    IDonationDetailsModel,
    IDonationDetailsSubmitResult,
} from '@/types/screening/donation-details';

const DONATION_DETAILS_ENDPOINT = '/api/register/donation-details';

const defaultDonationDetailsModel: IDonationDetailsModel = {
    ...defaultScreeningProgress,
    currentRegistrationStep: DashRegistrationStep.DonationDetails,

    hasIntendedRecipient: null,
    ddRelationshipToPatient: null,
    ddRecipFirstName: '',
    ddRecipLastName: '',
    ddKnowsRecipDob: null,
    ddRecipDob: null,
    recipientCenterId: null,
    recipientAtSameDashCenter: null,
    isReferral: false,
    relationshipOptions: [],
    recipientCenterOptions: [],
};

export const useDonationDetails = (registrationId: number, editKey: string) => {
    const url = `${DONATION_DETAILS_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultDonationDetailsModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<IDonationDetailsFormValues, DashRegistrationStep, IDonationDetailsSubmitResult>(
        url,
        (values) => ({
            hasIntendedRecipient: toBoolOrNull(values.hasIntendedRecipient),
            ddRelationshipToPatient: toIntOrNull(values.ddRelationshipToPatient),
            ddRecipFirstName: values.ddRecipFirstName,
            ddRecipLastName: values.ddRecipLastName,
            ddKnowsRecipDob: toBoolOrNull(values.ddKnowsRecipDob),
            ddRecipDob: values.ddRecipDob !== '' ? values.ddRecipDob : null,
            recipientCenterId: toIntOrNull(values.recipientCenterId),
            recipientAtSameDashCenter: toBoolOrNull(values.recipientAtSameDashCenter),
        }),
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
